import { useEffect, useState } from 'react';
import style from './index.module.scss';
import { useRouter } from 'next/router';
import { useI18n } from '@lib/i18n';

import { PERSONALISE_LOADING_TEXT } from '@lib/constants';

export default function LoadingPage({ header = '', text = '', timedHeaders = [] }) {
	const { t } = useI18n();

	const classes = {
		'/personalise': 'personalise',
	};

	const router = useRouter();

	const defaultHeader = header ? header : t('personalise.loading_text', PERSONALISE_LOADING_TEXT);

	const [activeHeader, setActiveHeader] = useState(defaultHeader);

	useEffect(() => {
		if (!timedHeaders || timedHeaders.length < 1) {
			setActiveHeader(defaultHeader);
			return;
		}

		const timers = timedHeaders.map((item) => {
			return setTimeout(() => {
				setActiveHeader(item.header);
			}, item.seconds * 1000);
		});

		return () => {
			timers.forEach((timer) => clearTimeout(timer));
		};
	}, [defaultHeader, timedHeaders]);

	return (
		<div
			className={`has-text-centered ${style.component} ${classes[router.pathname] ? style[classes[router.pathname]] : ''}`}
		>
			<div className={`loader`}>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
			<h2 className={`loader--text`}>{activeHeader}</h2>
			{text && <p className={`loader--text`}>{text}</p>}
		</div>
	);
}
